import { render, staticRenderFns } from "./homeMenuPix.vue?vue&type=template&id=6223d27a"
import script from "./homeMenuPix.vue?vue&type=script&lang=ts"
export * from "./homeMenuPix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports